<template>
  <v-container class="py-md-8" style="max-width: 750px">
    <h2 class="text-h2 flex-fill px-3 mb-6">Users</h2>
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="name"
      class="elevation-2"
      :search="search"
      :custom-filter="filter"
      :loading="loading"
    >
      <template v-slot:top>
        <div class="d-flex align-center pa-4">
          <v-text-field
            rounded
            flat
            filled
            type="search"
            v-model="search"
            dense
            hide-details=""
            placeholder="Search Users"
            class="mr-2 flex-fill"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                elevation="0"
                @click="openImport()"
                ><font-awesome-icon icon="upload"></font-awesome-icon
              ></v-btn>
            </template>
            <span>Import</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                color="primary"
                small
                elevation="0"
                @click="edit(null)"
                ><font-awesome-icon icon="plus"></font-awesome-icon
              ></v-btn>
            </template>
            <span>Add User</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              class="mr-2"
              @click="edit(item)"
            >
              <v-icon small>$edit</v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon @click="confirmDelete(item)">
              <v-icon small>$delete</v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="openConfirmDelete" max-width="400px">
      <v-card>
        <dialog-title
          v-model="openConfirmDelete"
          title="Confirm Delete"
          :disabled="loading"
        ></dialog-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <p class="text-body-1">
                You are about to delete tenant user:
                <strong class="red--text darken-1 font-weight-bold">{{
                  item.id
                }}</strong
                >. <br /><br />
                Are you sure?
              </p>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn
                :disabled="loading"
                text
                color="primary"
                @click="openConfirmDelete = false"
              >
                Cancel
              </v-btn>
              <v-btn
                :loading="loading"
                color="red darken-1"
                dark
                @click="deleteUser"
              >
                Yes, delete user
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <tenant-user ref="tenantUser" @reload="loadUsers"></tenant-user>
    <import ref="import" @reload="loadUsers"></import>
  </v-container>
</template>

<script>
import DialogTitle from "../../components/DialogTitle.vue";
import userService from "../../services/userService";
import TenantUser from "./tenant-user.vue";
import Import from "./tenant-users.import.vue";

export default {
  components: { DialogTitle, TenantUser, Import },
  data() {
    return {
      search: "",
      item: {},
      items: [],
      openConfirmDelete: false,
      pendingStateChanges: 0,
    };
  },
  computed: {
    tenantId() {
      return this.$store.state.tenantId;
    },
    headers() {
      return [
        {
          text: "Email",
          value: "id",
        },
        {
          text: "First Name",
          value: "firstName",
        },
        {
          text: "Last Name",
          value: "lastName",
        },
        // {
        //   text: "Role",
        //   value: "role",
        // },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          cellClass: "w-0 text-no-wrap",
          align: "center",
        },
      ];
    },
    loading() {
      return this.pendingStateChanges > 0;
    },
  },
  methods: {
    filter(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLowerCase()
          .indexOf(search.toLowerCase()) !== -1
      );
    },
    loadUsers() {
      this.pendingStateChanges++;

      return userService
        .getAll(this.tenantId)
        .then(
          (result) => {
            this.items = result;
          },
          () => {
            this.$store.dispatch(
              "notifications/error",
              "An unexpected error occurred while loading users. Please try again later."
            );
          }
        )
        .finally(() => this.pendingStateChanges--);
    },
    edit(item) {
      this.$refs.tenantUser.edit(item);
    },
    confirmDelete(item) {
      this.item = item;
      this.openConfirmDelete = true;
    },
    deleteUser() {
      this.pendingStateChanges++;

      userService
        .remove({ id: this.item.id, tenantId: this.tenantId })
        .then(
          () => {
            this.openConfirmDelete = false;
            this.loadUsers();
            this.$store.dispatch(
              "notifications/success",
              "Successfully deleted user."
            );
          },
          (error) => {
            console.warn(error);
            this.$store.dispatch(
              "notifications/error",
              "An unexpected error occurred while trying to delete user. Please try again later."
            );
          }
        )
        .finally(() => this.pendingStateChanges--);
    },
    openImport() {
      this.$refs.import.open();
    },
  },
  mounted() {
    this.loadUsers();
  },
};
</script>

<style>
.w-0 {
  width: 0;
}
</style>
